export const SSO_REDIRECT_QUERY_PARAM = "redirect";

export const OPEN_CART_QUERY_PARAM = "openCart";

const COMPLETE_PROFILE_PATH = "/complete-profile";

// Same list as AuthModal cleanup: params that drive the auth modal must not
// be round-tripped through SSO, or the modal could reopen after login
const AUTH_MODAL_QUERY_PARAMS = ["email", "goto", "step", "type", "invitationId"];

// Dummy base so relative-path canonicalization never matches a real host
const CANONICALIZATION_BASE = "https://internal.invalid";

// Guard against open redirects: only same-site paths ("/..." but not "//host",
// no "\" since browsers normalize backslashes to slashes). Canonicalizing with
// the URL parser also catches parser differentials (tab/CR/LF and other control
// chars are stripped by browsers, so "/\t/evil.com" resolves like "//evil.com")
export const isInternalPath = (path: string): boolean => {
  if (!path.startsWith("/") || path.startsWith("//") || path.includes("\\")) {
    return false;
  }
  try {
    return new URL(path, CANONICALIZATION_BASE).origin === CANONICALIZATION_BASE;
  } catch {
    return false;
  }
};

export const stripAuthModalParams = (asPath: string): string => {
  const [pathAndQuery, hash] = asPath.split("#");
  const [pathname, search] = pathAndQuery.split("?");
  if (!search) {
    return asPath;
  }
  const params = new URLSearchParams(search);
  AUTH_MODAL_QUERY_PARAMS.forEach((param) => params.delete(param));
  const queryString = params.toString();
  const cleanedPath = queryString ? `${pathname}?${queryString}` : pathname;
  return hash ? `${cleanedPath}#${hash}` : cleanedPath;
};

const appendOpenCartParam = (path: string): string => {
  const url = new URL(path, CANONICALIZATION_BASE);
  url.searchParams.set(OPEN_CART_QUERY_PARAM, "1");
  return `${url.pathname}${url.search}${url.hash}`;
};

export const getSsoCallbackURL = (
  redirectPath?: string | null,
  options?: { openCart?: boolean }
): string => {
  const base = `${window.location.origin}${COMPLETE_PROFILE_PATH}`;
  if (redirectPath && isInternalPath(redirectPath)) {
    const target = options?.openCart
      ? appendOpenCartParam(redirectPath)
      : redirectPath;
    return `${base}?${SSO_REDIRECT_QUERY_PARAM}=${encodeURIComponent(target)}`;
  }
  return base;
};
